/**
 * 建立一個具有指定頻道名稱的 BroadcastChannel 實例，並可選擇性地提供訊息處理函式。
 *
 * @param {string} channelName - 要建立的廣播頻道名稱。
 * @param {function} [onMessage] - 可選的回呼函式，用於處理接收到的訊息。
 *                                 該函式會接收一個 `MessageEvent` 物件作為參數。
 * @returns {Object} 返回一個包含以下方法的物件：
 *   - `postMessage(data: any): void` - 發送訊息到廣播頻道。
 *   - `destroy(): void` - 關閉廣播頻道並移除提供的訊息事件監聽器（如果有）。
 */
export const createBroadcastChannel = (channelName, onMessage) => {
  const channel = new BroadcastChannel(channelName)

  if (onMessage) {
    channel.addEventListener('message', onMessage)
  }

  return {
    postMessage: (data) => channel.postMessage(data),
    destroy: () => {
      if (onMessage) {
        channel.removeEventListener('message', onMessage)
      }
      channel.close()
    }
  }
}
